(function () {
  if (window.HollyVideoVisibility) {
    return;
  }

  var DEFAULT_THRESHOLD = 0.1;
  var DEFAULT_ROOT_MARGIN = '0px';
  var observers = new Map();
  var resizeTimer;

  function isMobile() {
    return window.innerWidth <= 576;
  }

  function getWrapper(video) {
    return video.closest('.hv-video-wrapper') || video.parentElement;
  }

  function getDatasetValue(video, key) {
    if (video.dataset && video.dataset[key]) {
      return video.dataset[key];
    }
    var wrapper = getWrapper(video);
    if (wrapper && wrapper.dataset && wrapper.dataset[key]) {
      return wrapper.dataset[key];
    }
    return '';
  }

  function getDevice(video) {
    var device = getDatasetValue(video, 'hvDevice');
    if (device) {
      return device;
    }
    var ancestor = video.closest('[data-hv-device]');
    if (ancestor) {
      return ancestor.getAttribute('data-hv-device');
    }
    return '';
  }

  function matchesDevice(video) {
    var device = getDevice(video);
    if (!device) {
      return true;
    }
    if (device === 'mobile') {
      return isMobile();
    }
    if (device === 'pc') {
      return !isMobile();
    }
    return true;
  }

  function getPoster(video) {
    var wrapper = getWrapper(video);
    if (!wrapper) {
      return null;
    }
    var device = getDevice(video);
    if (device) {
      var typed = wrapper.querySelector(
        '[data-hv-poster][data-hv-device="' + device + '"]',
      );
      if (typed) {
        return typed;
      }
    }
    return wrapper.querySelector('[data-hv-poster]');
  }

  function getEndImage(video) {
    var wrapper = getWrapper(video);
    if (!wrapper) {
      return null;
    }
    var device = getDevice(video);
    if (device) {
      var typed = wrapper.querySelector(
        '[data-hv-end][data-hv-device="' + device + '"]',
      );
      if (typed) {
        return typed;
      }
    }
    return wrapper.querySelector('[data-hv-end]');
  }

  function getHideClass(el) {
    return el ? el.getAttribute('data-hv-hide-class') : '';
  }

  function getShowClass(el) {
    return el ? el.getAttribute('data-hv-show-class') : '';
  }

  function getLoadedClass(video) {
    return getDatasetValue(video, 'hvLoadedClass');
  }

  function hideElement(el) {
    if (!el) return;
    var cls = getHideClass(el);
    if (cls) {
      el.classList.add(cls);
    } else {
      el.style.opacity = '0';
      el.style.pointerEvents = 'none';
    }
  }

  function showElement(el) {
    if (!el) return;
    var cls = getHideClass(el);
    if (cls) {
      el.classList.remove(cls);
    } else {
      el.style.opacity = '';
      el.style.pointerEvents = '';
    }
  }

  function showEndImage(el) {
    if (!el) return;
    var cls = getShowClass(el);
    if (cls) {
      el.classList.add(cls);
    } else {
      el.style.opacity = '1';
    }
  }

  function hideEndImage(el) {
    if (!el) return;
    var cls = getShowClass(el);
    if (cls) {
      el.classList.remove(cls);
    } else {
      el.style.opacity = '';
    }
  }

  function getObserverOptions(video) {
    var thresholdValue = getDatasetValue(video, 'hvThreshold');
    var rootMarginValue = getDatasetValue(video, 'hvRootMargin');
    var threshold = thresholdValue
      ? parseFloat(thresholdValue)
      : DEFAULT_THRESHOLD;
    var rootMargin = rootMarginValue || DEFAULT_ROOT_MARGIN;
    return { threshold: threshold, rootMargin: rootMargin };
  }

  function getObserver(video) {
    var options = getObserverOptions(video);
    var key = options.threshold + '|' + options.rootMargin;
    if (!observers.has(key)) {
      observers.set(
        key,
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var target = entry.target;
            if (!target) return;
            if (!matchesDevice(target)) {
              target.pause();
              return;
            }
            if (entry.isIntersecting) {
              activateVideo(target);
            } else {
              target.pause();
            }
          });
        }, options),
      );
    }
    return observers.get(key);
  }

  function activateVideo(video) {
    if (!video) return;
    if (!video.dataset.hvActivated) {
      video.dataset.hvActivated = 'true';
      video.load();
    }
    var playPromise = video.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.catch(function () {
        var poster = getPoster(video);
        showElement(poster);
        var loadedClass = getLoadedClass(video);
        if (loadedClass) {
          video.classList.remove(loadedClass);
        }
      });
    }
  }

  function isInViewport(video) {
    var rect = video.getBoundingClientRect();
    var viewportHeight =
      window.innerHeight || document.documentElement.clientHeight;
    var viewportWidth =
      window.innerWidth || document.documentElement.clientWidth;
    return (
      rect.width > 0 &&
      rect.height > 0 &&
      rect.bottom > 0 &&
      rect.right > 0 &&
      rect.top < viewportHeight &&
      rect.left < viewportWidth
    );
  }

  function bindVideo(video) {
    if (!video) return;
    var observer = getObserver(video);
    observer.observe(video);

    if (video.dataset.hvBound) {
      return;
    }
    video.dataset.hvBound = 'true';

    var poster = getPoster(video);
    var endImage = getEndImage(video);
    var loadedClass = getLoadedClass(video);

    var reveal = function () {
      if (video.readyState >= 2) {
        hideElement(poster);
        hideEndImage(endImage);
        if (loadedClass) {
          video.classList.add(loadedClass);
        }
      }
    };

    var conceal = function () {
      showElement(poster);
      if (loadedClass) {
        video.classList.remove(loadedClass);
      }
    };

    video.addEventListener('loadeddata', reveal);
    video.addEventListener('canplay', reveal);
    video.addEventListener('playing', reveal);
    video.addEventListener('loadstart', function () {
      showElement(poster);
      hideEndImage(endImage);
    });
    video.addEventListener('error', conceal);

    if (!video.hasAttribute('loop')) {
      video.addEventListener('ended', function () {
        showEndImage(endImage);
      });
    }

    requestAnimationFrame(function () {
      if (!matchesDevice(video)) {
        return;
      }
      if (isInViewport(video)) {
        activateVideo(video);
      }
    });
  }

  function scan(root) {
    var scope = root || document;
    var videos = scope.querySelectorAll('.hv-video');
    videos.forEach(function (video) {
      bindVideo(video);
      if (!matchesDevice(video)) {
        video.pause();
      }
    });
  }

  function refresh() {
    observers.forEach(function (observer) {
      observer.disconnect();
    });
    observers.clear();
    scan(document);
  }

  function init(root) {
    scan(root || document);
  }

  window.HollyVideoVisibility = {
    init: init,
    refresh: refresh,
  };

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      refresh();
    }, 200);
  });
})();
